<template>
    <layout>
        <main role="main" class="background-employer-dashboard col-12">
            <div class="container">
                <div class="mt-5 mt-lg-6rem">
                    <h1 class="font-poppins font-weight-extra-light color-blue">{{ title }}</h1>
                    <h6 class="font-poppins font-weight-light font-size-18 color-blue">{{ subtitle }}</h6>
                </div>

                <div class="row mt-5 mt-md-5 mb-3">
                    <div class="col-12">
                        <flash-messages :hideErrors="true"></flash-messages>
                    </div>

                    <div class="col-12">
                        <div class="card border-radius-8 shadow">
                            <div class="card-body p-0">
                                <div class="row m-0 p-0">
                                    <div class="col-12 col-md-3 p-0 border-md-right">
                                        <settings-tabs :tab="tabName"></settings-tabs>
                                    </div>
                                    <div class="col-12 col-md-9">
                                        <div id="v-pills-tabContent">
                                            <div class="tab-pane fade py-4 px-lg-4 show active" id="v-pills-account"
                                                 role="tabpanel" aria-labelledby="v-pills-account-tab">

                                                <slot></slot>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </main>
    </layout>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from "@/Shared/TextInput";
import SettingsTabs from "@/Pages/Settings/Shared/SettingsTabs";
import FlashMessages from "@/Shared/FlashMessages";
import Checkbox from "@/Shared/Checkbox";
import FormError from "@/Shared/FormError";
import SelectInput from "@/Shared/SelectInput";

export default {
    components: {
        FormError,
        Checkbox,
        TextInput,
        Layout,
        SettingsTabs,
        FlashMessages,
        SelectInput,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            required: true,
        },
        tabName: {
            type: String,
            required: true,
        },
    }
}
</script>
